// Module
var code = `<table ng-table="\$ctrl.tableConfig" class="table">
  <thead>
  <tr>
    <th>No.</th>
    <th>Group name</th>
    <th>Group address</th>
    <th>Collection day</th>
    <th>Collection start time</th>
    <th>Collection end time</th>
    <th>Latest due date</th>
    <th>Total principal amount</th>
    <th>Total principal balance</th>
    <th>Total due amount</th>
    <th>Total overdue amount</th>
    <th>Total outstanding amount</th>
    <th>Action</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$data" ng-if="\$data">
    <td>{{ \$ctrl.getRowNo(\$index, \$ctrl.tableConfig) }}</td>
    <td>{{ item.groupName }}</td>
    <td>{{ item.groupAddress }}</td>
    <td>{{ item.collectionDay}}</td>
    <td>{{ item.collectionTimeFrom | prettyTimeOnly }}</td>
    <td>{{ item.collectionTimeTo | prettyTimeOnly }}</td>
    <td>{{ item.latestDueDate | prettyDate }}</td>
    <td>{{ item.totalPrincipalAmount | nxCurrency }}</td>
    <td>{{ item.totalPrincipalBalance | nxCurrency}}</td>
    <td>{{ item.totalDueAmount | nxCurrency }}</td>
    <td>{{ item.totalOverdueAmount | nxCurrency }}</td>
    <td>{{ (item.totalOutstandingAmount) | nxCurrency }}</td>
    <td>
      <button class="btn" ng-click="\$ctrl.showGroupMembersModal({group: item})">View members</button>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/collections/payment/group/collections-payment-group.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;